module.exports = __webpack_public_path__ + "static/media/netresto-2.266e594b.png";